module.exports = __webpack_public_path__ + "static/media/cmr_5.90e8132f.jpg";